import script from "./UploadTemplateStep.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadTemplateStep.vue?vue&type=script&setup=true&lang=js"

import "./UploadTemplateStep.vue?vue&type=style&index=0&id=6dc4b170&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc4b170"]])

export default __exports__